import Info from '../../Components/ProductInfo/ProductInfo';
import {
  useDispatch,
  useSelector,
  Dispatch,
  SetStateAction,
} from 'react-redux';
import {
  setProductInfoData,
  setCodes,
  deleteCodes,
  setCodesTitle,
  addBrands,
  addMeasurementUnit,
} from '../slice';
import React, { ReactNode } from 'react';
import {
  addUnit as unitReq,
  addBrand as brandReq,
} from '../../tools/commonRequests';
interface IProps {
  setShowModal: (show) => void;
  setModalTitle: Dispatch<SetStateAction<string>>;
  // setOkText: Dispatch<SetStateAction<string>>;
  setModalContent: Dispatch<SetStateAction<ReactNode>>;
  otherCodeForm;
  setDraft: () => void;
  setActive: () => void;
  setArchived: () => void;
  pageTitle: string;
  disabled?: boolean;
}

const ProductInfoSection = (props: IProps) => {
  const info = useSelector((state: any) => state.productSet.productInfo);
  const brands = useSelector((state: any) => state.productSet.brands);
  const measurementUnits = useSelector(
    (state: any) => state.productSet.measurementUnits,
  );
  const status = useSelector((state: any) => state.productSet.status);
  const dispatch = useDispatch();

  const {
    setShowModal,
    setModalTitle,
    // setOkText,
    setModalContent,
    otherCodeForm,
    setDraft,
    setActive,
    setArchived,
    pageTitle,
    disabled,
  } = props;
  const deletePopFun = (index) => {
    dispatch(deleteCodes({ index: index }));
  };
  const codesOnChange = (e, index) => {
    dispatch(setCodesTitle({ code: e, index }));
  };
  const setData = (data) => {
    dispatch(setProductInfoData(data));
  };
  const otherCodeFormFinish = (values) => {
    dispatch(
      setCodes({ title: values.Title, code: values.Code }),
      setShowModal(false),
    );
  };
  const addUnit = (unit) => {
    unitReq({ unit }).then((u) => {
      dispatch(addMeasurementUnit(u));
    });
  };
  const addBrand = (brand) => {
    brandReq({ name: brand }).then((b) => {
      dispatch(addBrands(b));
    });
  };

  return (
    <Info
      disabled={disabled}
      title={pageTitle}
      addUnit={addUnit}
      addBrand={addBrand}
      brands={brands}
      measurementUnits={measurementUnits}
      status={status}
      setModalContent={setModalContent}
      // setOkText={setOkText}
      formdata={info}
      setShowModal={setShowModal}
      setModalTitle={setModalTitle}
      otherCodeForm={otherCodeForm}
      deletePopFun={deletePopFun}
      setCodes={setCodes}
      codesOnChange={codesOnChange}
      setData={setData}
      otherCodeFormFinish={otherCodeFormFinish}
      setDraft={setDraft}
      setActive={setActive}
      setArchived={setArchived}
    />
  );
};
export default ProductInfoSection;
